import { faDiamond as farDiamond, faStar as farStar } from "@fortawesome/pro-regular-svg-icons";
import {
	faDiamond,
	faDiamondHalf,
	faDiamondHalfStroke,
	faStar,
	faStarHalf,
	faStarHalfStroke,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "@tosize/ui";
import { type ComponentProps, useMemo } from "react";

interface StarsProps extends ComponentProps<"div"> {
	rating: number;
	variant?: "stars" | "diamonds";
	color?: "text-success-medium" | "text-primary-medium";
	hideEmpty?: boolean;
}

export function Level(props: StarsProps) {
	const {
		rating,
		variant = "stars",
		color = "text-success-medium",
		hideEmpty = false,
		className,
		...remainingProps
	} = props;

	const level = useMemo(() => {
		const totalrating = rating / 2;
		const totalLevel = 5;

		const full = Math.floor(totalrating);
		const half = Math.ceil(totalrating - full);
		const empty = totalLevel - Math.ceil(half + full);

		return { full, half, empty };
	}, [rating]);

	return (
		<span className={cn("flex items-center", color, className)} {...remainingProps}>
			{Array.from({ length: level.full }).map((_value, index) => (
				<FontAwesomeIcon
					icon={variant === "diamonds" ? faDiamond : faStar}
					key={index}
					fixedWidth
				/>
			))}

			{Array.from({ length: level.half }).map((_value, index) => (
				<FontAwesomeIcon
					icon={
						hideEmpty
							? variant === "diamonds"
								? faDiamondHalf
								: faStarHalf
							: variant === "diamonds"
								? faDiamondHalfStroke
								: faStarHalfStroke
					}
					key={index}
					fixedWidth
				/>
			))}

			{!hideEmpty &&
				Array.from({ length: level.empty }).map((_value, index) => (
					<FontAwesomeIcon
						icon={variant === "diamonds" ? farDiamond : farStar}
						key={index}
						fixedWidth
					/>
				))}
		</span>
	);
}
